import { useLocation } from "react-router-dom";
import cn from "classnames";

import {
  SwitchAnimation,
  RenderAnimation,
} from "../../Animation/Animation.jsx";
import { FetchComponent } from "../../FetchComponent/FetchComponent.jsx";

import { ScheduleSelect } from "./ScheduleSelect/ScheduleSelect.jsx";
import { ScheduleToggler } from "./ScheduleToggler/ScheduleToggler.jsx";

export const ScheduleSwitchers = ({
  setWeek,
  branches,
  setBranches,
  modules,
  setModules,
  setDate,
  date,
}) => {
  const location = useLocation();
  const isForming = location.pathname.includes("forming");
  return (
    <SwitchAnimation keyAnimation={location.key}>
      <div className="row col-sm-12 mx-auto">
        <div
          className={cn("col-sm-10 mt-2 mt-md-0 text-center mx-auto", {
            "col-md-4": !isForming,
            "col-md-6": isForming,
          })}
        >
          <FetchComponent
            heightContainer="10vh"
            keyAnimation={branches.loading}
            loading={branches.loading}
            error={branches.error}
          >
            <ScheduleSelect
              title="Выберите филиал"
              value={branches.currentBranch}
              onChange={(e) => {
                setBranches({
                  ...branches,
                  currentBranch: e.target.value,
                });
              }}
            >
              {branches.data.map((item, index) => {
                const { ref, address } = item;
                return (
                  <option key={index} value={ref}>
                    {address}
                  </option>
                );
              })}
            </ScheduleSelect>
          </FetchComponent>
        </div>
        <div
          className={cn("col-sm-10 mt-2 mt-md-0 text-center mx-auto", {
            "col-md-4": !isForming,
            "col-md-6": isForming,
          })}
        >
          <FetchComponent
            heightContainer="10vh"
            keyAnimation={modules.loading}
            loading={modules.loading}
            error={modules.error}
          >
            <ScheduleSelect
              title="Выберите модуль"
              value={modules.currentModule}
              onChange={(e) => {
                setModules({ ...modules, currentModule: e.target.value });
              }}
            >
              <option value="">Все модули</option>
              {modules.data.map((item, index) => {
                const { name } = item;
                return (
                  <option key={index} value={item.name}>
                    {name}
                  </option>
                );
              })}
            </ScheduleSelect>
          </FetchComponent>
        </div>

        <div className="col-sm-10 col-md-4 mt-2 mt-md-0 mx-auto text-center">
          <RenderAnimation>
            {!isForming && (
              <ScheduleToggler
                title="Выберите даты"
                leftClickHandler={() => {
                  setWeek((prev) => prev - 1);
                  setDate({
                    ...date,
                    today: date.today.clone().subtract(7, "days"),
                  });
                }}
                rightClickHandler={() => {
                  setWeek((prev) => prev + 1);
                  setDate({
                    ...date,
                    today: date.today.clone().add(7, "days"),
                  });
                }}
              >
                <span>{date.startOfWeek.format("D MMMM")}</span>
                <span>{date.endOfWeek.format("D MMMM")}</span>
              </ScheduleToggler>
            )}
          </RenderAnimation>
        </div>
      </div>
    </SwitchAnimation>
  );
};
